// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.message-section {
  flex: 1;
  overflow-y: auto;
}

.message-list .date.divider i {
  margin-right: 5px;
}

.message-list .item .text .highlight.link {
  color: #4183c4;
}

.message-list .item .text .highlight.bold {
  font-weight: bold;
}

.message-list .item .text .table.dropdown,
.message-list .item .text .table.dropdown .popup.trigger {
  max-width: 100%;
}

.message-list .item .text .table.dropdown .caption {
  overflow: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/components/messages/messages.css"],"names":[],"mappings":"AAAA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".message-section {\n  flex: 1;\n  overflow-y: auto;\n}\n\n.message-list .date.divider i {\n  margin-right: 5px;\n}\n\n.message-list .item .text .highlight.link {\n  color: #4183c4;\n}\n\n.message-list .item .text .highlight.bold {\n  font-weight: bold;\n}\n\n.message-list .item .text .table.dropdown,\n.message-list .item .text .table.dropdown .popup.trigger {\n  max-width: 100%;\n}\n\n.message-list .item .text .table.dropdown .caption {\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
